export default {
	title: "Functions",
	description: "Manage temple spiritual and administrative functions",
	searchPlaceholder: "Search functions...",
	create: "New Function",
	deleteConfirmation: "Are you sure you want to delete the function {name}?",
	deleteWarning: "This action is permanent. All person assignments to this function will be removed.",
	confirmDeleteMessage: "Are you sure you want to delete this function? This action cannot be undone.",
	name: "Name",
	category: "Category",
	personCount: "Assigned People",
	peopleCount: "People",
	minimumJourney: "Minimum Journey",
	noRequirement: "No Requirement",
	noCategory: "No category",
	newCategory: "New category",
	minimumJourneyStage: "Minimum Journey Stage",
	minimumJourneyStageHint: "Minimum journey stage required to perform this function (optional)",
	status: {
		active: "Active",
		inactive: "Inactive",
		all: "All",
	},
	empty: {
		description: "Register the spiritual and administrative functions of the temple",
		title: "No functions found",
	},
	stats: {
		total: "Total",
		withPersons: "With People",
		withoutPersons: "Without People",
	},
	messages: {
		activated: "Function activated successfully",
		deactivated: "Function deactivated successfully",
		createError: "Error creating function",
		deleteError: "Error deleting function",
		fetchError: "Error loading functions",
		loadError: "Error loading functions",
		saveError: "Error saving function",
		createSuccess: "Function created successfully",
		updateSuccess: "Function updated successfully",
		deleteSuccess: "Function deleted successfully",
	},
	addFunction: "Add Function",
	selectFunction: "Select Function",
	requiredStage: "Required Stage",
	minimumJourneyStageRequired: "Requires minimum stage: {stage}",
	journeyStageNotMet: "Current stage ({current}) does not meet minimum requirement ({required})",
	noCurrentStage: "No current stage",
	currentJourneyStage: "Current Journey Stage",
	function: "Function",
	notes: "Notes",
	noFunctions: "No functions assigned",
	since: "Since",
	deactivate: "Deactivate",
	reactivate: "Reactivate",
	endedAt: "Ended At",
};
